import { registerLocaleData } from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import localeDe from "@angular/common/locales/de";
import localeEs from "@angular/common/locales/es";
import localeFr from "@angular/common/locales/fr";
import localeIt from "@angular/common/locales/it";
import localeRu from "@angular/common/locales/ru";
import localeZh from "@angular/common/locales/zh";
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import {
  PatternlibAngularCommonModule,
  PatternlibAngularFormsModule,
} from "@liebherr/patternlib-angular";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { DocsFilterComponent } from "./components/docs-filter/docs-filter.component";
import { DocsListComponent } from "./components/docs-list/docs-list.component";
import { DocsToolbarComponent } from "./components/docs-toolbar/docs-toolbar.component";
import { DocsZipDownloadComponent } from "./components/docs-zip-download/docs-zip-download.component";
import { ProductFinderComponent } from "./components/product-finder/product-finder.component";
import { LoadingStatusInterceptor } from "./http-interceptors/loading-status.interceptor";
import { AccessDeniedPage } from "./pages/access-denied/access-denied.component";
import { AccessDeniedSelectProductPage } from "./pages/access-denied-select-product/access-denied-select-product.component";
import { HomePage } from "./pages/home/home.component";
import { NotFoundPage } from "./pages/not-found/not-found.component";
import { ProductDocsPage } from "./pages/product-docs/product-docs.component";
import { TechnicalErrorPage } from "./pages/technical-error/technical-error.component";
import { FullNamePipe } from "./pipes/full-name.pipe";
import { InitialsPipe } from "./pipes/initials.pipe";

registerLocaleData(localeDe);
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeRu);
registerLocaleData(localeIt);
registerLocaleData(localeZh);

export function HttpLoaderFactory(client: HttpClient) {
  const basePath = document.getElementsByTagName("base")[0].href;
  return new TranslateHttpLoader(client, basePath + "assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    DocsListComponent,
    DocsZipDownloadComponent,
    ProductDocsPage,
    NotFoundPage,
    AccessDeniedPage,
    AccessDeniedSelectProductPage,
    TechnicalErrorPage,
    DocsFilterComponent,
    HomePage,
    ProductFinderComponent,
    DocsToolbarComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    PatternlibAngularCommonModule,
    PatternlibAngularFormsModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "de-DE" },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingStatusInterceptor,
      multi: true,
    },
    InitialsPipe,
    FullNamePipe,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
